import { render } from "./EditBookingDialog.vue?vue&type=template&id=70cdc627"
import script from "./EditBookingDialog.vue?vue&type=script&lang=js"
export * from "./EditBookingDialog.vue?vue&type=script&lang=js"

import "./EditBookingDialog.vue?vue&type=style&index=0&id=70cdc627&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__